var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBubDef4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: "100%",
      height: "100%"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 222,
    height: 138,
    viewBox: "0 0 222 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ic_bub_def",
    x: 0,
    y: 0,
    width: 222,
    height: 138,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#ic_bub_def)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_bub_def-2",
    "data-name": "ic_bub_def",
    d: "M183.56,132.464a34.87,34.87,0,0,0-23.989-57.53A53.914,53.914,0,0,0,96,60.552,53.914,53.914,0,0,0,32.429,74.934a34.871,34.871,0,0,0,0,69.571A53.914,53.914,0,0,0,96,158.888a53.9,53.9,0,0,0,51.738-3.912c21.1,7.521,37.8-.032,38.524-.368a3.776,3.776,0,0,0,1.783-5.119C188,149.4,183.8,140.932,183.56,132.464Z",
    transform: "translate(15 -43.72)",
    fill: "#dddbd7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBubDef4);
export default __webpack_public_path__ + "static/media/ic_bub_def-4.003fef67745df2b8c77df36b00dafbd4.svg";
export { ForwardRef as ReactComponent };